export const firebaseConfig = {
    apiKey: "AIzaSyA4BMQYbolwHtADfgl7v4icUJuIxGE7Ssc",
    authDomain: "distributely-dev.firebaseapp.com",
    projectId: "distributely-dev",
    storageBucket: "distributely-dev.firebasestorage.app",
    messagingSenderId: "907578603925",
    appId: "1:907578603925:web:58929cae600107144e5e9c"
  };